<div class="row" *ngIf="showLayout">
  <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12"></div>
  <div class="col-xl-9 col-lg-9 col-md-12 col-sm-12 d-flex flex-row-reverse">
    <app-button
      [variant]="'danger'"
      [startIcon]="'fa-solid fa-link-slash'"
      [classes]="classes"
      (click)="onClick()"
    >
      {{ label || ('admin.store.disconnect' | translate) }}
    </app-button>
  </div>
</div>

<app-button
  *ngIf="!showLayout"
  [variant]="'danger'"
  [startIcon]="'fa-solid fa-link-slash'"
  [classes]="classes"
  (click)="onClick()"
>
  {{ label || ('admin.store.disconnect' | translate) }}
</app-button>
